import { UserNotificationSettings } from "../users";
import { WorkspaceRole, WorkspaceSeatType } from "./workspace-role";
import { z } from "zod";
export const WorkspaceMembership = z.object({
    id: z.string(),
    userId: z.string(),
    workspaceId: z.string(),
    workspaceRole: z.nativeEnum(WorkspaceRole),
    seatType: WorkspaceSeatType,
    notificationSettings: UserNotificationSettings,
    isPrimaryOwner: z.boolean().nullish(),
    isDeactivated: z.boolean(),
});
export const UpdateMembershipRolesInput = z.object({
    members: z.array(z.object({
        userId: z.string(),
        role: z.nativeEnum(WorkspaceRole),
        seatType: WorkspaceSeatType.optional(),
        isPrimaryOwner: z.boolean().optional(),
    })),
});
